import SEOHead from '@/components/base/SEOHead';

export default function Terminos() {
  return (
    <>
      <SEOHead
        title="Términos y Condiciones | Suvi Digital"
        description="Términos y condiciones de uso de los servicios de Suvi Digital, agencia de marketing digital especializada en agencias de viaje."
        keywords="terminos condiciones Suvi Digital, contrato marketing digital, condiciones servicio agencia viaje"
        canonical="https://suvidigital.com/terminos-y-condiciones"
        schemaType="WebPage"
      />
      <main className="min-h-screen">
        {/* Hero */}
        <section className="relative min-h-[320px] md:min-h-[380px] flex items-center overflow-hidden">
          <div className="absolute inset-0 animate-gradient bg-gradient-to-br from-primary-100 via-background-50 to-secondary-100" />
          <div className="absolute top-20 right-20 w-72 h-72 bg-primary-200/30 rounded-full blur-3xl animate-float-slow" />

          <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 xl:px-16 pt-24 md:pt-28">
            <div className="max-w-4xl">
              <span className="inline-block bg-primary-50 text-primary-600 text-sm font-semibold px-4 py-1.5 rounded-full mb-5 border border-primary-200/50">
                Legal
              </span>
              <h1 className="font-heading text-4xl md:text-5xl font-bold text-foreground-900 mb-5 leading-tight">
                Términos y{' '}
                <span className="text-gradient">Condiciones</span>
              </h1>
              <p className="text-foreground-500 text-lg leading-relaxed max-w-2xl">
                Última actualización: 18 de agosto de 2026
              </p>
            </div>
          </div>
        </section>

        {/* Content */}
        <section className="bg-white py-16 md:py-20">
          <div className="px-4 md:px-6 lg:px-10 xl:px-16">
            <div className="max-w-3xl mx-auto bg-background-50 border border-background-200/60 rounded-2xl p-6 md:p-10">
              <div className="space-y-8 text-foreground-700 text-sm md:text-base leading-relaxed">
                <div>
                  <h2 className="font-heading font-semibold text-lg text-foreground-900 mb-2">1. Objeto</h2>
                  <p>
                    Los presentes Términos y Condiciones regulan el uso de los servicios ofrecidos por Suvi Digital, agencia de marketing digital y desarrollo de software, con domicilio en Lima, Perú. Al contratar cualquiera de nuestros servicios, el cliente acepta íntegramente estas condiciones.
                  </p>
                </div>

                <div>
                  <h2 className="font-heading font-semibold text-lg text-foreground-900 mb-2">2. Servicios Ofrecidos</h2>
                  <p className="mb-2">Suvi Digital ofrece los siguientes servicios:</p>
                  <ul className="list-disc pl-5 space-y-1.5">
                    <li>Estrategia de marketing digital</li>
                    <li>Branding e identidad visual</li>
                    <li>Diseño y desarrollo web / e-commerce</li>
                    <li>Gestión de redes sociales y contenidos</li>
                    <li>Publicidad digital (Meta Ads, Google Ads)</li>
                    <li>Email marketing</li>
                    <li>SEO y analítica digital</li>
                    <li>Desarrollo de software a medida</li>
                    <li>Licenciamiento de Operturi (software para agencias de viaje)</li>
                  </ul>
                </div>

                <div>
                  <h2 className="font-heading font-semibold text-lg text-foreground-900 mb-2">3. Contratación y Pagos</h2>
                  <p>
                    El pago se realiza en dos partes: 50% para dar inicio al proyecto y 50% al finalizar. Los pagos podrán ser en soles (PEN) o dólares (USD) vía depósito bancario o transferencia. El IGV (18%) se aplica solo de requerir boleta o factura. El proyecto se inicia una vez aprobado el presupuesto y recibido el primer depósito.
                  </p>
                </div>

                <div>
                  <h2 className="font-heading font-semibold text-lg text-foreground-900 mb-2">4. Cronograma y Entregas</h2>
                  <p>
                    Cada proyecto tendrá un calendario de presentaciones y entregas definido en la propuesta. Recibido un entregable, el cliente cuenta con tres días hábiles máximo para plantear observaciones. De no hacerlo, se considera aprobado. Las presentaciones se realizan de manera online (Zoom, Google Meet o similar).
                  </p>
                </div>

                <div>
                  <h2 className="font-heading font-semibold text-lg text-foreground-900 mb-2">5. Propiedad Intelectual</h2>
                  <p>
                    Una vez cancelado el 100% del proyecto, los derechos de propiedad intelectual de los entregables (logos, diseños, contenido del sitio web) son transferidos al cliente. Suvi Digital se reserva el derecho de mostrar el trabajo en su portafolio y redes sociales, salvo acuerdo en contrario.
                  </p>
                </div>

                <div>
                  <h2 className="font-heading font-semibold text-lg text-foreground-900 mb-2">6. Alcance y Cambios</h2>
                  <p>
                    El precio acordado cubre exclusivamente lo descrito en la propuesta aprobada. Cualquier trabajo adicional o cambios fuera del alcance original generarán reajustes según el tiempo adicional invertido. El precio no incluye hosting, dominio, fotografía/video nuevo, ni contenido redactado a menos que se especifique.
                  </p>
                </div>

                <div>
                  <h2 className="font-heading font-semibold text-lg text-foreground-900 mb-2">7. Suspensión del Proyecto</h2>
                  <p>
                    El proyecto podrá paralizarse en caso de incumplimiento de pagos por parte del cliente; se retoma una vez regularizada la situación. Si el cliente decide cancelar el proyecto después de haber iniciado, no se realizará devolución del adelanto.
                  </p>
                </div>

                <div>
                  <h2 className="font-heading font-semibold text-lg text-foreground-900 mb-2">8. Soporte Post-Lanzamiento</h2>
                  <p>
                    Los proyectos web incluyen 3 meses de soporte técnico post-lanzamiento sin costo adicional, cubriendo corrección de errores y ajustes menores. No incluye desarrollo de nuevas funcionalidades ni rediseños.
                  </p>
                </div>

                <div>
                  <h2 className="font-heading font-semibold text-lg text-foreground-900 mb-2">9. Limitación de Responsabilidad</h2>
                  <p>
                    Suvi Digital no garantiza resultados específicos de ventas, tráfico o posicionamiento en buscadores derivados de los servicios de marketing digital, dado que estos dependen de múltiples factores externos. Sí garantizamos la ejecución profesional de las estrategias acordadas.
                  </p>
                </div>

                <div>
                  <h2 className="font-heading font-semibold text-lg text-foreground-900 mb-2">10. Ley Aplicable</h2>
                  <p>
                    Estos Términos y Condiciones se rigen por las leyes de la República del Perú. Cualquier controversia será resuelta ante los tribunales competentes de la ciudad de Lima.
                  </p>
                </div>

                <div>
                  <h2 className="font-heading font-semibold text-lg text-foreground-900 mb-2">11. Modificaciones</h2>
                  <p>
                    Suvi Digital se reserva el derecho de modificar estos Términos y Condiciones en cualquier momento. Las modificaciones entrarán en vigor desde su publicación en el sitio web.
                  </p>
                </div>

                <div>
                  <h2 className="font-heading font-semibold text-lg text-foreground-900 mb-2">12. Contacto</h2>
                  <p>
                    Para cualquier consulta sobre estos términos, puede contactarnos en <a href="mailto:hernan@suvidigital.com" className="text-primary-600 hover:underline">hernan@suvidigital.com</a> o al teléfono +51 989 307 864.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}